import { Link } from "react-router-dom";
import { formatUnits } from "viem";
import moment from "moment";
import { getTokenByChainIdAndAddress } from "common";
import { TransactionButton } from "./TransactionButton";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function DirectDonationsList(props) {
  const contributions = props.contributions.flat().sort((a, b) => (Number(b.timestamp) || Number.MAX_SAFE_INTEGER) - (Number(a.timestamp) || Number.MAX_SAFE_INTEGER));
  return /*#__PURE__*/_jsx(_Fragment, {
    children: contributions.length > 0 && contributions.map(contribution => {
      var _contribution$applica, _contribution$applica2;
      const token = getTokenByChainIdAndAddress(contribution.chainId, contribution.tokenAddress);
      let formattedAmount = "N/A";
      if (token) {
        formattedAmount = `${formatUnits(BigInt(contribution.amount), token.decimals)} ${token.code}`;
      }
      return /*#__PURE__*/_jsxs("div", {
        className: "w-full flex items-center px-4 justify-between font-modern-era-regular font-normal text-base/[26px]",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex flex-col gap-1 flex-1",
          children: [/*#__PURE__*/_jsx(Link, {
            className: `underline inline-block lg:pr-2 lg:max-w-[300px] max-w-[75px] 2xl:max-w-fit truncate`,
            title: contribution.projectId,
            to: `/projects/${contribution.projectId}`,
            target: "_blank",
            children: (_contribution$applica = (_contribution$applica2 = contribution.application) === null || _contribution$applica2 === void 0 || (_contribution$applica2 = _contribution$applica2.project) === null || _contribution$applica2 === void 0 ? void 0 : _contribution$applica2.name) !== null && _contribution$applica !== void 0 ? _contribution$applica : `Project Id: ${contribution.projectId.slice(0, 6) + "..." + contribution.projectId.slice(-6)}`
          }), /*#__PURE__*/_jsx("div", {
            className: "text-sm text-gray-500",
            children: timeAgo(Number(contribution.timestamp))
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex-1 text-center truncate",
          children: [/*#__PURE__*/_jsxs("span", {
            children: [formattedAmount, " "]
          }), /*#__PURE__*/_jsxs("span", {
            className: "text-grey-400",
            children: ["/ $", contribution.amountInUsd.toFixed(2)]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "flex-1 flex justify-end",
          children: /*#__PURE__*/_jsx(TransactionButton, {
            chainId: contribution.chainId,
            txHash: contribution.transactionHash
          })
        })]
      });
    })
  });
}
function timeAgo(timestamp) {
  return moment(timestamp * 1000).fromNow();
}